export enum ProductType {
  ChemicalDrug = 0,

  MilkPowder = 1,

  Supplement = 2,

  NaturalRemedy = 3,

  TraditionalDrug = 4,

  Essentials = 5,

  Cosmetic = 6,
}
